
<template>
<div class="redirect-container">
    <div class="content">
      <div class="logo">
        <img src="https://res.wx.qq.com/a/wx_fed/assets/res/NTI4MWU5.ico" alt="微信图标">
      </div>
      <h1>正在打开“问鼎知肤”公众号</h1>
      <div class="loading" v-if="!showButton">
        <!-- <div class="spinner"></div> -->
      </div>
      <!-- <p class="tips" v-if="showButton">{{ tips }}</p> -->
      <button 
        v-if="true" 
        class="open-btn" 
        @click="getPhoneNumber">
        授权获取微信手机号
      </button>
      <p class="tips" v-if="formattedPhone">已获取手机号：{{ formattedPhone }}</p>
    </div>
  </div>

  
</template>

<script>
  import wx from 'weixin-js-sdk';

  export default {
    name: 'bindPhone',
    data() {
      return{
        showButton: true,
        step: 1,
        phoneNumber: '',
        loading: false,
        errorMessage: '',
        openId: '',
        appId: 'YOUR_WECHAT_APP_ID' // 实际应用中应通过后端传递
      }
    },
    computed: {
      formattedPhone() {
        if (!this.phoneNumber) return '';
        return this.phoneNumber.substring(0, 3) + '****' + this.phoneNumber.substring(7);
      }
    },
    mounted() {
      // new URLSearchParams(window.location.search).get('openId') || 
      this.openId = this.parseURLParams('openId');
      this.appId = this.parseURLParams('appId');
      // 网页URL
      console.log("In bindPhone, 传入URL参数，openId and appId：", this.openId, this.appId);

      // 从后端获取服务号ID
      // this.getAppId();
      // 初始化微信JS-SDK
      this.initWechatSDK();
    },
    methods: {
      getAppId() {
        // 模拟获取AppId - 实际应用中应通过后端API获取
        this.appId = 'wxbe7ec83ba9498419';
      },
      initWechatSDK() {
        console.error('In bindPhone, 开始 微信JS-SDK初始化');
        // 实际应用中，签名应由后端API提供
        wx.config({
          debug: false,
          appId: this.appId,
          timestamp: Date.now(),
          nonceStr: this.generateNonceStr(16),
          signature: 'abcd899sdjakfjadlkjowialdkfakdjljlkj', // 需要后端生成签名
          jsApiList: ['getPhoneNumber']
        });
        
        wx.ready(() => {
          console.log('In bindPhone, 微信JS-SDK初始化成功');
        });
        
        wx.error((err) => {
          console.error('In bindPhone, 微信JS-SDK初始化失败:', err);
          this.errorMessage = '微信功能初始化失败，请刷新页面重试';
        });
      },
      
      generateNonceStr(length) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
          result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
      },
      
      getPhoneNumber() {
        this.loading = true;
        this.errorMessage = '';
        
        wx.invoke('getPhoneNumber', {}, (res) => {
          this.loading = false;
          console.log('In bindPhone, invoke getPhoneNumber, res from wx server:', res);          
          if (res.err_msg === 'getPhoneNumber:ok') {
            const encryptedData = res.encryptedData;
            const iv = res.iv;            
            // 发送到后端解密
            fetch('/decryptPhone', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                openId: this.openId,
                encryptedData: encryptedData,
                iv: iv
              })
            })
            .then(response => response.json())
            .then(data => {
              console.log('In bindPhone, 解密手机号结果:', data);
              // const resultDiv = document.getElementById('result');
              // if (data.code === 0) {
              //   resultDiv.innerHTML = `手机号授权成功：${data.phoneNumber}`;
              //   resultDiv.className = 'result success';
              //   resultDiv.style.display = 'block';
                
              //   // 3秒后跳转
              //   setTimeout(() => {
              //     window.location.href = '/success?phone=' + data.phoneNumber;
              //   }, 3000);
              // } else {
              //   resultDiv.innerHTML = `授权失败：${data.message}`;
              //   resultDiv.className = 'result error';
              //   resultDiv.style.display = 'block';
              // }
            })
            .catch(error => {
              console.error('In bindPhone, Error:', error);
              // const resultDiv = document.getElementById('result');
              // resultDiv.innerHTML = '网络请求失败，请重试';
              // resultDiv.className = 'result error';
              // resultDiv.style.display = 'block';
            });

            // 模拟API请求 - 实际应发送到后端解密
            console.error('In bindPhone, 模拟手机号绑定成功.');
            setTimeout(() => {
              this.phoneNumber = '13800138000'; // 模拟解密后的手机号
              this.step = 2;
            }, 3000);

          } else {
            this.errorMessage = '获取手机号失败，请重试';
            console.error('微信获取手机号失败:', res);
          }
        });
      },
      
      confirmPhone() {
        this.loading = true;
        this.errorMessage = '';
        
        // 模拟API请求 - 实际应发送手机号到后端绑定
        setTimeout(() => {
          this.loading = false;
          this.step = 3;
        }, 800);
      },
      
      completeProcess() {
        alert('授权流程完成！在实际应用中，这里会跳转到服务页面');
        // 实际应用中: window.location.href = '/dashboard';
      },

      // 手动解析URL参数
      parseURLParams(keyword){
        try{
          const url = window.location.href;
          const searchStr = url.split('?')[1];
          const params = searchStr.split('&');
          for(let item of params){
            let param = item.split('=');
            if(param[0] === keyword){
              console.log("parse", keyword, ', value: ', param[1]);
              return param[1]
            } 
          }
          return null
        }catch(e){
          console.error("In bindPhone, parseURLParams error:", e);
          return null
        }        
      },
    }
  };
</script>



<style scoped>
.redirect-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f8f8f8;
  padding: 0 20px;
  box-sizing: border-box;
}

.content {
  max-width: 500px;
  width: 100%;
  text-align: center;
  background-color: #fff;
  border-radius: 12px;
  padding: 30px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.logo {
  margin-bottom: 20px;
}

.logo img {
  width: 60px;
  height: 60px;
}

h1 {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 500;
}

.loading {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: #07C160;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.tips {
  font-size: 14px;
  color: #999;
  margin: 20px 0;
}

.open-btn {
  background-color: #07C160;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  width: 80%;
  max-width: 300px;
}

.open-btn:hover {
  background-color: #06AD56;
}

.open-btn:active {
  background-color: #069C4F;
}
</style>